<template>
  <div id="ranking-board">
    <div class="ranking-board-title">库存记录数量</div>
    <dv-scroll-ranking-board :config="config" />
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'RankingBoard',
  data () {
    return {
      config: {
        data: [],
        rowNum: 9
      }
    }
  },
  methods: {
    initData() {
  	  let that = this
  	  axios({
  	    method:'get',
  	    url: that.baseUrl + "/datav/left/auth"
  	  }).then(function(resp){
  	    let res = resp.data;
  	    if (res.code === 200) {
  	      let data = res.data;
          that.config.data = data;
          // *dataV里面的组件props均未设置deep监听，刷新props时，要直接生成新的props对象（基础数据类型除外），或完成赋值操作后使用ES6拓展运算符生成新的props对象
          that.config = { ...that.config }

  	    }
  	  }).catch(resp => {
  	    console.log('请求失败：' + resp.status + ',' + resp.statusText);
  	  });
    }
  },
  mounted () {
    const { initData } = this
    initData()
    setInterval(initData, 10000)
  }
}
</script>

<style lang="less">
#ranking-board {
  width: 20%;
  box-shadow: 0 0 3px blue;
  display: flex;
  flex-direction: column;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;
  padding: 0px 30px;

  .ranking-board-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }

  .dv-scroll-ranking-board {
    flex: 1;
  }
}
</style>
